import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import {
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface,
  PerfectScrollbarModule,
} from 'ngx-perfect-scrollbar';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { AddAIRItemsComponent } from 'app/components/auditorbench/auditsummary/add-airitems/add-airitems.component';
import { AddProcessDepartmentComponent } from './components/add-process-department/add-process-department.component';
import { AttachmentlistComponent } from 'app/components/auditorbench/auditsummary/attachmentlist/attachmentlist.component';
import { AudititemlogComponent } from './components/audititemlog/audititemlog.component';
import { AuditlogsComponent } from './components/auditlogs/auditlogs.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { CommonModule } from '@angular/common';
import { CommonairComponent } from './components/commonair/commonair.component';
import { CustomMessages } from './components/custom-messages/custom-messages';
import { DefinescopeComponent } from './components/definescope/definescope.component';
import { DeleteProcessComponent } from './components/delete-process/delete-process.component';
import { DragDropDirective } from './components/file-drag/drag-drop.directive';
import { EasyDialogComponent } from './components/easy-dialog/easy-dialog.component';
import { EasyProgressComponent } from './components/easy-progress/easy-progress.component';
import { EditairitemsComponent } from 'app/components/auditorbench/auditsummary/editairitems/editairitems.component';
import { ErrorCodeComponent } from './components/error-code/error-code.component';
import { FileDragDropComponent } from './components/file-drag/file-drag-drop.component';
import { FilterSidenavComponent } from './components/filter-sidenav/filter-sidenav.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { FormlyModule } from '@ngx-formly/core';
import { ManagepermissionComponent } from './components/managepermission/managepermission.component';
import { MatCarouselModule } from '@ngmodule/material-carousel';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MaterialModule } from './material.module';
import { NgModule } from '@angular/core';
import { NgProgressModule } from '@ngx-progressbar/core';
import { NgProgressRouterModule } from '@ngx-progressbar/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { NgxPaginationModule } from 'ngx-pagination'; // <-- import the module
import { NgxPopperModule } from 'ngx-popper';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { PostcommentsComponent } from 'app/components/auditorbench/auditsummary/postcomments/postcomments.component';
import { QuillModule } from 'ngx-quill';
import { RouterModule } from '@angular/router';
import { SearchairComponent } from 'app/components/auditorbench/auditsummary/searchair/searchair.component';
import { TemplatefilterComponent } from './components/templatefilter/templatefilter.component';
import { Text3dComponent } from './components/text3d/text3d.component';
import { TranslatePipe } from './pipes/translate.pipe';
import { WorkflowlistComponent } from './components/workflowlist/workflowlist.component';
import { FooterComponent } from './components/footer/footer.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { TeamDetailComponent } from './components/team-detail/team-detail.component';
import { NonNcscopeComponent } from './components/non-ncscope/non-ncscope.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { AuditeeAuditorComponent } from './components/auditee-auditor/auditee-auditor.component';
import { MailDownloadComponent } from './components/mail-download/mail-download.component';
import { AllObservationComponent } from './components/all-observation/all-observation.component';

import { DocumentrepoComponent } from './components/documentrepo/documentrepo.component';
import { ReturnlogComponent } from './components/returnlog/returnlog.component';
import { AuditorvisibilityRemarkComponent } from 'app/components/auditorbench/auditsummary/auditorvisibility-remark/auditorvisibility-remark.component';
import { EditorModule } from '@tinymce/tinymce-angular';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  wheelPropagation: true,
  minScrollbarLength: 120,
};

import { AgGridRemarkComponent } from 'app/shared/components/ag-grid-remark/ag-grid-remark.component';
import { AgGridModule } from 'ag-grid-angular';
import { AgGridAngular } from 'ag-grid-angular';
import 'ag-grid-enterprise';
import {
  ButtonRendererComponent,
  DialogBoxComponent,
} from './components/ag-grid-remark/button-renderer.component';
import { PrivacyPolicyPopupComponent } from 'app/components/sessions/privacy-policy-popup/privacy-policy-popup.component';

const THIRD_MODULES = [
  MaterialModule,
  FlexLayoutModule,
  NgProgressModule,
  NgProgressRouterModule,
  NgSelectModule,
  FormlyModule,
  FormlyMaterialModule,
  NgxPopperModule,
  PerfectScrollbarModule,
  MatCarouselModule,
  MatProgressSpinnerModule,
  NgxMaterialTimepickerModule,
  NgxPaginationModule,
  NgxMatSelectSearchModule,
  AgGridModule,
];
const COMPONENTS = [
  AgGridRemarkComponent,
  CustomMessages,
  BreadcrumbComponent,
  PageHeaderComponent,
  ErrorCodeComponent,
  Text3dComponent,
  EasyProgressComponent,
  EasyDialogComponent,
  FileDragDropComponent,
  FilterSidenavComponent,
  DeleteProcessComponent,
  AddProcessDepartmentComponent,
  DefinescopeComponent,
  TemplatefilterComponent,
  SearchairComponent,
  EditairitemsComponent,
  CommonairComponent,
  AddAIRItemsComponent,
  AttachmentlistComponent,
  AuditlogsComponent,
  PostcommentsComponent,
  AudititemlogComponent,
  ManagepermissionComponent,
  FooterComponent,
  ReturnlogComponent,
  AuditorvisibilityRemarkComponent,
];
const COMPONENTS_DYNAMIC = [
  EasyDialogComponent,
  WorkflowlistComponent,
  CustomMessages,
  TeamDetailComponent,
  NonNcscopeComponent,
  AuditeeAuditorComponent,
  AllObservationComponent,
  ButtonRendererComponent,
  DialogBoxComponent,
  PrivacyPolicyPopupComponent,
];
const DIRECTIVES = [];
const PIPES = [TranslatePipe, SafeHtmlPipe];

@NgModule({
  declarations: [
    ...COMPONENTS,
    ...DIRECTIVES,
    ...PIPES,
    ...COMPONENTS_DYNAMIC,
    FileDragDropComponent,
    DragDropDirective,
    FilterSidenavComponent,
    DeleteProcessComponent,
    AddProcessDepartmentComponent,
    DefinescopeComponent,
    TemplatefilterComponent,
    WorkflowlistComponent,
    CommonairComponent,
    AuditorvisibilityRemarkComponent,
    AttachmentlistComponent,
    PostcommentsComponent,
    AudititemlogComponent,
    ManagepermissionComponent,
    TeamDetailComponent,
    MailDownloadComponent,
    DocumentrepoComponent,
    ReturnlogComponent,
    AgGridRemarkComponent,
    ButtonRendererComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    ...THIRD_MODULES,
    QuillModule.forRoot(),
    AgGridModule.withComponents([ButtonRendererComponent]),
    EditorModule,
  ],
  providers: [
    CustomMessages,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
  ],
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    TranslateModule,
    TranslateModule,
    ReactiveFormsModule,
    DocumentrepoComponent,
    ...THIRD_MODULES,
    ...COMPONENTS,
    ...DIRECTIVES,
    ...PIPES,
  ],
  entryComponents: COMPONENTS_DYNAMIC,
})
export class SharedModule {}
